/* eslint-disable react/require-default-props */
/* eslint-disable max-len */
import PropTypes from 'prop-types';
import React from 'react';

import { LiftsTrailsMeasurementTypes } from '@powdr/constants';

import {
  Trails, Lifts, Snowfall, Temperature, WindSpeed,
  ParkingStatus, RoadStatus, TerrainStatus,
  LiftStatus, TrailStatus,
  CurrentTemp, RetailService,
  RetailServiceStatus,
} from './components';
import { StyledDorMeasurementItem } from './styles';

const MeasurementTypes = {
  LIFTS_TRAILS_VALUE: 'lifts_trails_value',
  SNOW_REPORT_VALUE: 'snow_report_value',
  TEMPERATURE_VALUE: 'temperature_value',
  CURRENT_TEMP: 'current_temp',
  WIND_SPEED_VALUE: 'wind_speed_value',
  PARKING_STATUS: 'parking_status',
  ROAD_STATUS: 'road_status',
  TERRAIN_STATUS: 'terrain_status',
  LIFT_STATUS: 'lift_status',
  TRAIL_STATUS: 'trail_status',
  RETAIL_SERVICE_STATUS: 'retail_service_status',
  RETAIL_SERVICE_OPEN: 'open_retail_service',
};

export const DorMeasurementItem = ({
  className = null,
  parentColorProfile = null,
  icon = null,
  centerItemsInColumn = false,
  measurementLabel = null,
  measurementType = null,
  measurementDisplayType = null,
  ignoreLiftTypes = null,
  ignoreTrailTypes = null,
  ignoreTrailDifficulty = null,
  ignoreGroomStatus = null,
  includeInOpenCount = null,
  liftsTrailsMeasurement = null,
  snowReportMeasurement = null,
  road = null,
  terrain = null,
  lift = null,
  trail = null,
  sensor = null,
  sensorLocation = null,
  retailService = null,
  sectors = null,
  season = null,
}) => {
  const MeasurementDataComponentMap = {
    [MeasurementTypes.SNOW_REPORT_VALUE]: Snowfall,
    [MeasurementTypes.TEMPERATURE_VALUE]: Temperature,
    [MeasurementTypes.WIND_SPEED_VALUE]: WindSpeed,
    [MeasurementTypes.PARKING_STATUS]: ParkingStatus,
    [MeasurementTypes.ROAD_STATUS]: RoadStatus,
    [MeasurementTypes.TERRAIN_STATUS]: TerrainStatus,
    [MeasurementTypes.LIFT_STATUS]: LiftStatus,
    [MeasurementTypes.TRAIL_STATUS]: TrailStatus,
    [MeasurementTypes.RETAIL_SERVICE_STATUS]: RetailServiceStatus,
    [MeasurementTypes.CURRENT_TEMP]: CurrentTemp,
    [MeasurementTypes.RETAIL_SERVICE_OPEN]: RetailService,
    [LiftsTrailsMeasurementTypes.OPEN_LIFTS]: Lifts,
    [LiftsTrailsMeasurementTypes.OPEN_TRAILS]: Trails,
    [LiftsTrailsMeasurementTypes.MILES_OF_SKIING]: Trails,
    [LiftsTrailsMeasurementTypes.ACRES_OF_SKIING]: Trails,
    [LiftsTrailsMeasurementTypes.KILLINGTON_GROOMED]: Trails,
  };

  const measurement = (measurementType === MeasurementTypes.LIFTS_TRAILS_VALUE)
    ? liftsTrailsMeasurement
    : measurementType;

  return (
    <StyledDorMeasurementItem
      className={className}
      $centerItemsInColumn={centerItemsInColumn}
    >
      {(MeasurementDataComponentMap[measurement]) && React.createElement(
        MeasurementDataComponentMap[measurement],
        {
          icon,
          measurementDisplayType,
          measurement,
          measurementLabel,
          liftsTrailsMeasurement,
          parentColorProfile,
          ignoreLiftTypes,
          ignoreTrailTypes,
          ignoreTrailDifficulty,
          ignoreGroomStatus,
          includeInOpenCount,
          snowReportMeasurement,
          road,
          sensor,
          sensorLocation,
          terrain,
          lift,
          trail,
          retailService,
          sectors,
          season,
        },
      )}
    </StyledDorMeasurementItem>
  );
};

DorMeasurementItem.propTypes = {
  className: PropTypes.string,
  parentColorProfile: PropTypes.string,
  icon: PropTypes.string,
  centerItemsInColumn: PropTypes.bool,
  measurementLabel: PropTypes.string,
  measurementType: PropTypes.string,
  measurementDisplayType: PropTypes.string,
  ignoreLiftTypes: PropTypes.arrayOf(PropTypes.string),
  ignoreTrailTypes: PropTypes.arrayOf(PropTypes.string),
  ignoreTrailDifficulty: PropTypes.arrayOf(PropTypes.string),
  ignoreGroomStatus: PropTypes.arrayOf(PropTypes.string),
  includeInOpenCount: PropTypes.arrayOf(PropTypes.string),
  liftsTrailsMeasurement: PropTypes.string,
  snowReportMeasurement: PropTypes.string,
  season: PropTypes.string,
  road: PropTypes.shape({
    value: PropTypes.string,
    uuid: PropTypes.string,
  }),
  terrain: PropTypes.shape({
    value: PropTypes.string,
    uuid: PropTypes.string,
  }),
  lift: PropTypes.shape({
    value: PropTypes.string,
    uuid: PropTypes.string,
  }),
  trail: PropTypes.shape({
    value: PropTypes.string,
    uuid: PropTypes.string,
  }),
  retailService: PropTypes.shape({
    value: PropTypes.string,
    uuid: PropTypes.string,
  }),
  sectors: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      uuid: PropTypes.string,
    }),
  ),
  sensor: PropTypes.string,
  sensorLocation: PropTypes.string,
};
